import { axiosRetry } from '@/plugins/axios';

export const getGatewayMerchantId = currencyCode => {
    const merchantIds = {
        GBP: import.meta.env.VITE_ADYEN_MERCHANT_ID,
        EUR: import.meta.env.VITE_ADYEN_MERCHANT_ID_EUR,
        SEK: import.meta.env.VITE_ADYEN_MERCHANT_ID_SEK,
        CHF: import.meta.env.VITE_ADYEN_MERCHANT_ID_CHF,
        DKK: import.meta.env.VITE_ADYEN_MERCHANT_ID,
        CAD: import.meta.env.VITE_ADYEN_MERCHANT_ID_CAD,
        AUD: import.meta.env.VITE_ADYEN_MERCHANT_ID_AUD,
        USD: import.meta.env.VITE_ADYEN_MERCHANT_ID_USD
    };

    if (!merchantIds[currencyCode]) {
        throw new Error(`Currency code "${currencyCode}" is not supported`);
    }

    return merchantIds[currencyCode];
};

/**
 * Get available payment methods from Adyen
 * @param {Object} params - Payment method parameters
 * @param {string} params.shopperLocale - Shopper locale (e.g., 'en-US')
 * @param {string} params.value - Payment amount value
 * @param {string} params.currency - Currency code
 * @param {string} params.venueId - Venue ID
 * @param {string} params.countryCode - Country code
 * @returns {Promise<Object>} Payment methods response
 */
export const getPaymentMethods = async params => {
    try {
        const { data } = await axiosRetry.get('/adyen/payments/methods', {
            params,
            timeout: 10000
        });

        return data;
    } catch (error) {
        throw error;
    }
};

/**
 * Create a payment with Adyen
 * @param {Object} payload - Payment creation payload
 * @returns {Promise<Object>} Payment creation response
 */
export const createPayment = async payload => {
    try {
        const { data } = await axiosRetry.post(
            '/adyen/payments/create',
            payload
        );

        return data;
    } catch (error) {
        throw error;
    }
};

/**
 * Submit additional details for 3DS authentication
 * @param {Object} payload - Additional details payload
 * @returns {Promise<Object>} Additional details response
 */
export const submitAdditionalDetails = async payload => {
    try {
        const { data } = await axiosRetry.post(
            '/adyen/payments/additional-details',
            payload
        );

        return data;
    } catch (error) {
        throw error;
    }
};
